import { render, staticRenderFns } from "./HomeNotifications.vue?vue&type=template&id=466b1958&scoped=true&"
import script from "./HomeNotifications.vue?vue&type=script&lang=js&"
export * from "./HomeNotifications.vue?vue&type=script&lang=js&"
import style0 from "./HomeNotifications.vue?vue&type=style&index=0&id=466b1958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466b1958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBadge,VCard,VCardText,VCol,VContainer,VRow})
